"use strict";

import { newVueComponent, waitForDependencies } from "../../_imports/utils/utils.common";

waitForDependencies(() => newVueComponent("main-navigation-search", () => require("./_imports/main-navigation-search.vue").default));